import {
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { IUsuario } from 'src/app/interfaces';
import { IDeleteUsuarioRouteParams } from 'src/app/interfaces/usuario/IDeleteUsuarioRouteParams';
import { AuthenticationService, UsuarioService } from 'src/app/services';

@Component({
  selector: 'app-modal-excluir-usuario',
  templateUrl: './modal-excluir-usuario.component.html',
  styleUrls: ['./modal-excluir-usuario.component.scss']
})
export class ModalExcluirUsuarioComponent implements OnDestroy {
  @Output() deleteUser = new EventEmitter<IUsuario>();
  @ViewChild('ModalExclui') ModalExclui: TemplateRef<any>;
  subscriptions$ = new Subscription();
  userToDelete: IUsuario;

  constructor(
    private usuarioService: UsuarioService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal
  ) {}

  openModal(user: IUsuario) {
    this.modalService.open(this.ModalExclui, {
      centered: true,
      size: 'lg'
    });
    this.userToDelete = user;
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  doDeletar() {
    let routeParams: IDeleteUsuarioRouteParams = {
      idUsuario: Number(this.authenticationService.obterToken().id),
      usuarioId: this.userToDelete.id
    };
    this.subscriptions$.add(
      this.usuarioService.deleteUsuario(routeParams).subscribe({
        complete: () => {
          this.deleteUser.emit(this.userToDelete);
          this.fecharModal();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
